import ResetPasswordForm from "./reset-password-form.container";

export default ResetPasswordForm;